import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faAngleLeft,
  // faBan,
  faBars,
  faBuilding,
  faBullhorn,
  faCheck,
  faCheckCircle,
  faDoNotEnter,
  faEllipsisV,
  faEnvelope,
  faFilePdf,
  faHandshake,
  faPen,
  faPlusCircle,
  faQuestionCircle,
  faSignOut,
  faSitemap,
  faStar,
  faStopwatch,
  faTachometerSlow,
  faTimes,
  faTrashAlt,
  faUser,
  faUsers,
  faUserCheck,
  faUserSlash,
  faVideo,

  // used in teams
  faChartPie,
  faAtomAlt,
  faBalanceScale,
  faBook,
  faBullseyeArrow,
  faCalculator,
  faCar,
  faCashRegister,
  faCog,
  faCrosshairs,
  faCube,
  faDollarSign,
  faDrawCircle,
  faFlask,
  faFlowerTulip,
  faGem,
  faGift,
  faGlobe,
  faGlobeAsia,
  faHeart,
  faHeartRate,
  faIceCream,
  faIndustry,
  faKey,
  faLeaf,
  faLightbulb,
  faMicroscope,
  faPalette,
  faPodium,
  faSackDollar,
  faSeedling,
  faShieldAlt,
  faShoppingBag,
  faShoppingCart,
  faTire,
  faTrain,
  faTruck,
  faUserFriends,
  faWallet,
  faWarehouseAlt,
  faMicrophone,
  faPuzzlePiece,
  faPaperPlane,
  faPhone,
  faSuitcaseRolling,
  faBackpack,
  faPaperclip,
  faShareAlt,

  // editor
  // faH1,
  // faH2,
  // faH3,
  // faBold,
  // faItalic,
  // faUnderline,
  // faListOl,
  // faListUl,
  // faTextSize,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faAngleLeft,
  // faBan,
  faBars,
  faBuilding,
  faBullhorn,
  faCheck,
  faCheckCircle,
  faDoNotEnter,
  faEllipsisV,
  faEnvelope,
  faFilePdf,
  faHandshake,
  faPen,
  faPlusCircle,
  faQuestionCircle,
  faSignOut,
  faSitemap,
  faStar,
  faStopwatch,
  faTimes,
  faTachometerSlow,
  faTrashAlt,
  faUser,
  faUsers,
  faUserCheck,
  faUserSlash,
  faVideo,

  // used in teams
  faChartPie,
  faAtomAlt,
  faBalanceScale,
  faBook,
  faBullseyeArrow,
  faCalculator,
  faCar,
  faCashRegister,
  faCog,
  faCrosshairs,
  faCube,
  faDollarSign,
  faDrawCircle,
  faFlask,
  faFlowerTulip,
  faGem,
  faGift,
  faGlobe,
  faGlobeAsia,
  faHeart,
  faHeartRate,
  faIceCream,
  faIndustry,
  faKey,
  faLeaf,
  faLightbulb,
  faMicroscope,
  faPalette,
  faPodium,
  faSackDollar,
  faSeedling,
  faShieldAlt,
  faShoppingBag,
  faShoppingCart,
  faTire,
  faTrain,
  faTruck,
  faUserFriends,
  faWallet,
  faWarehouseAlt,
  faMicrophone,
  faPuzzlePiece,
  faPaperPlane,
  faPhone,
  faSuitcaseRolling,
  faBackpack,
  faPaperclip,
  faShareAlt,

  // editor
  // faH1,
  // faH2,
  // faH3,
  // faBold,
  // faItalic,
  // faUnderline,
  // faListOl,
  // faListUl,
  // faTextSize,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
